
import React, { createContext, useState, useEffect } from 'react';

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);

    useEffect(() => {
        fetch('/assets/app-config.json')
            .then(response => response.json())
            .then(config => setConfig(config))
            .catch(error => console.error('Error loading config:', error));
    }, []);

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
};

export { ConfigContext };
export default ConfigContext;